module.exports = __webpack_public_path__ + "img/exclamation-mark.c7d48282.svg";